// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有开发环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)

//用户自定义的路由，如果需要增加路由设置，请在这里填写，以免程序更新后被覆盖
const customRouter = [

];

export default customRouter;


// WEBPACK FOOTER //
// ./src/router/customRouters.js